import styled from "styled-components";
import DemoEnvIcon from "../../../../assets/createEnvAssets/DemoEnvIcon";
import TrainingIcon from "../../../../assets/createEnvAssets/TrainingIcon";

const ButtonStyle = styled.div`
  background: var(--color-workspace-bg-page-area);
  width: ${props => (props.small ? "120px" : "230px")}; 
  height: ${props => (props.small ? "40px" : "50px")};
  border: 1px solid var(--color-createenv-stepper-input-radio-btn-bg);
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
  gap: 15px;

  &.active {
    border: 1px solid var(--unnamed-color-ec407a);
    background: var(--color-brand-pink-light-selected);
    border: 1px solid var(--color-brand-pink-primary);
    border-radius: 10px;
    color: #EC407A;
  }
`;


const SelectEnvButton = (props) => {
        const { isActive, onClick, title, small } = props;
        return (
                <ButtonStyle
                        id={title.split(' ').join('-')}
                        className={isActive && 'active'}
                        onClick={onClick}
                        small={small}
                >
                        {title === "Demo" ? <DemoEnvIcon /> : <TrainingIcon />}
                        <span style={{ flex: "0 1" }}>{title}</span>
                </ButtonStyle>
        );
};

export default SelectEnvButton;
